
(() => {
  // ---------- tiny helpers ----------
  let BOOTING = true;
  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));
  const money = (c) => { try { return Shopify.formatMoney(c, window.theme?.moneyFormat || "${{amount}}"); } catch { return `$${(c/100).toFixed(2)}`; } };
  const withW = (u,w)=>{ try{const x=new URL(u,location.origin); x.searchParams.set('width',String(w)); return x.toString();} catch { return u + (u.includes('?')?'&':'?') + 'width=' + w; } };
  const srcset=(u,a=[200,300,400,500,600,700,800,1000])=>a.map(w=>`${withW(u,w)} ${w}w`).join(', ');
  const GALLERY_SIZES = '(max-width:699px) calc(100vw - 40px),(max-width:999px) calc(100vw - 64px), min(1100px, 819px - 96px)';
  const urlVariant = (() => { try { const v=new URL(location.href).searchParams.get('variant'); return v ? Number(v) : null; } catch { return null; } })();
  const hasScene7 = m => typeof m?.alt === 'string' && /scene7/i.test(m.alt);

  // ---------- PDP scope ----------
  const picker = document.querySelector('variant-picker.variant-picker');
  if (!picker) return;

  const SCOPE  = picker.closest('.product') || picker.closest('section') || picker.closest('main') || document;
  const IN_SCOPE = (node) => !!node && (node === SCOPE || SCOPE.contains(node));

  const formId = picker.getAttribute('form-id');
  const form   = document.getElementById(formId) || qs(`#${CSS.escape(formId)}`);
  if (!form || !IN_SCOPE(form)) return;

  const atcBtn = form.querySelector('button[type="submit"],[name="add"]');
  const priceNode     = qs('.price-list .h4, .price-list [data-price]', SCOPE) || qs('.price-list', SCOPE);
  const compareAtNode = qs('.price-list [data-compare-price], .price-list .compare-price', SCOPE);
  const buyButtons    = qs('buy-buttons.buy-buttons', SCOPE);
  const wishlist = qs('#smartwishlist', SCOPE);

  const fsByLegend = (startsWith) =>
    qsa('.variant-picker__option', picker).find(fs => (qs('legend',fs)?.textContent||'').trim().toLowerCase().startsWith(startsWith));
  const sizeFS   = fsByLegend('size');
  const colorFS  = fsByLegend('color');

  const sizePop  = sizeFS?.querySelector('x-popover');
  const sizeList = sizePop?.querySelector('.popover__value-list');
  const sizeBtnText = sizeFS?.querySelector('button.select > span[id$="selected-value"]');
  const sizeBtn     = sizeFS?.querySelector('button.select[aria-controls]');
  const colorLegendText = colorFS?.querySelector('.variant-picker__option-info .h-stack span:last-child');

  const initialVariantJSON = (() => { try { return JSON.parse(picker.querySelector('script[data-variant]')?.textContent||'null'); } catch { return null; } })();

  function currentHandle() {
    try {
      const parts = location.pathname.split('/').filter(Boolean);
      const i = parts.indexOf('products');
      if (i >= 0 && parts[i+1]) return parts[i+1];
    } catch {}
    return picker.getAttribute('handle') || null;
  }
  let activeHandle = currentHandle();

  // ---------- product.js cache ----------
  const CACHE = new Map();
  async function getProduct(handle){
    if (!handle) return null;
    if (CACHE.has(handle)) return CACHE.get(handle);
    const rsp = await fetch(`/products/${handle}.js`, {credentials:'same-origin'});
    if (!rsp.ok) return null;
    const json = await rsp.json(); CACHE.set(handle, json); return json;
  }

  // ---------- URL ----------
  function setURL(handle, variantId){
    if (!handle) return;
    try {
      const u = new URL(location.href);
      u.pathname = `/products/${handle}`;
      if (variantId) u.searchParams.set('variant', String(variantId));
      else u.searchParams.delete('variant');
      history.replaceState(null, '', u.toString());
    } catch {}
  }

  // -- multi-currency price helpers
  // --- Derive pattern from a server-rendered price node
  let __pat;
  const formatCents = (c, trim=true) => {
    __pat ||= (() => {
      const n = document.querySelector('sale-price'); // probe once
      if (!n) return { pre:'', suf:'', dec:'.' };
      const x = n.cloneNode(true);
      x.querySelectorAll('.sr-only,.visually-hidden').forEach(e=>e.remove());
      const t = x.textContent.trim();
      const m = t.match(/^(.*?)([\d.,\u00A0\u202F\s]+)(.*?)$/) || [, '', '', ''];
      const dec = (m[2].match(/([.,])\d{1,3}\s*$/)||[])[1] || '.';
      return { pre:m[1], suf:m[3], dec };
    })();
    const v = Math.abs(c||0)/100, neg = (c||0) < 0;
    const fd = trim && Math.round(v*100)%100===0 ? 0 : 2;
    const num = new Intl.NumberFormat(__pat.dec===',' ? 'de-DE' : 'en-US',
      { minimumFractionDigits: fd, maximumFractionDigits: fd }).format(v);
    return (neg?'-':'') + __pat.pre + num + __pat.suf;
  };

  // ---------- IDs / price / ATC / events ----------
  function updateAllIdInputs(variantId) {
    qsa(`input[name="id"]`, SCOPE).forEach(inp => {
      inp.value = String(variantId);
      inp.dispatchEvent(new Event('input',{bubbles:true}));
      inp.dispatchEvent(new Event('change',{bubbles:true}));
    });
    const ptForm  = document.getElementById(`${formId}-payment-installment`);
    const ptInput = ptForm?.querySelector('input[name="id"]');
    if (ptInput) ptInput.value = String(variantId);
    qsa('shopify-payment-terms', SCOPE).forEach(el => el.setAttribute('variant-id', String(variantId)));
    try { Shopify?.PaymentButton?.init?.(); } catch {}
  }
  function setPriceAndATC(variant){
    /*if (priceNode) priceNode.textContent = money(variant.price);*/
    if (priceNode) {
      //const formatted = money(variant.price); 
      //priceNode.textContent = formatted.replace(/([.,]00)(?=\s*\D*$)/, "");
      priceNode.textContent = formatCents(variant.price);
    }
    if (compareAtNode) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        //compareAtNode.textContent = money(variant.compare_at_price);
        compareAtNode.textContent = formatCents(variant.compare_at_price);
        compareAtNode.style.display = '';
      } else {
        compareAtNode.style.display = 'none';
      }
    }

    if (atcBtn) {
      const ok = !!variant.available;
      atcBtn.disabled = !ok;
      atcBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');

      const labelEl = atcBtn.querySelector('[data-button-text]') || atcBtn;

      // Pull canonical texts from data-attributes if present; otherwise sane fallbacks
      const addText     = atcBtn.getAttribute('data-add-text')
                      || atcBtn.dataset.addText
                      || 'Add to cart';
      const soldOutText = atcBtn.getAttribute('data-sold-out-text')
                      || atcBtn.dataset.soldOutText
                      || 'Sold out';

      // Do NOT save current text as the default—use the stable strings above
      labelEl.textContent = ok ? addText : soldOutText;
    }
  }

  function dispatchVariantChange(variant){
    const evt = new CustomEvent('variant:change', {bubbles:true, detail:{variant}});
    picker.dispatchEvent(evt); form.dispatchEvent(evt); buyButtons?.dispatchEvent(evt);
  }
  function updateVariantScript(variant){
    const script = picker.querySelector('script[data-variant][type="application/json"]'); if (!script) return;
    try { script.textContent = JSON.stringify({ ...variant, selling_plan_allocations: variant.selling_plan_allocations || [], quantity_rule: variant.quantity_rule || {min:1,max:null,increment:1} }); } catch {}
  }
  function applyVariant(product, variant, {updateUrl=true, track = false} = {}) {
    if (!variant) return;
    if (sizeBtnText) sizeBtnText.textContent = variant.option1 || variant.title || '';
    if (sizeBtn) sizeBtn.setAttribute('data-selected-label', sizeBtnText?.textContent || '');
    updateAllIdInputs(variant.id);
    setPriceAndATC(variant);
    updateVariantScript(variant);
    if (updateUrl) setURL(product.handle || activeHandle, variant.id);
    dispatchVariantChange(variant);
    //events
    try { if(track) {window.JRNL.fireVariantView(product, variant);} } catch(e){}
    // wishlist
    if( wishlist ){
      wishlist.dataset.product = String(product.id);
      wishlist.dataset.variant = String(variant.id);
      wishlist.setAttribute('data-product', wishlist.dataset.product);
      wishlist.setAttribute('data-variant', wishlist.dataset.variant);
    }
  }

  // ---------- gallery ----------
  function grefs() {
    const root    = qs('product-gallery.product-gallery', SCOPE);
    const imgList = root?.querySelector('.product-gallery__image-list');
    const contents= imgList?.querySelector('.contents');
    const carousel= contents?.querySelector('scroll-carousel.product-gallery__carousel');
    const sticky  = root?.querySelector('safe-sticky.product-gallery__thumbnail-list');
    const nav     = sticky?.querySelector('product-gallery-navigation');
    return { root, imgList, contents, carousel, sticky, nav };
  }
  function ensureCarousel() {
    const { root, imgList, contents, carousel } = grefs(); if (!root) return null;
    let il=imgList, ct=contents, cr=carousel;
    if (!il) { il=document.createElement('div'); il.className='product-gallery__image-list'; root.insertBefore(il, root.firstChild); }
    if (!ct) { ct=document.createElement('div'); ct.className='contents'; il.appendChild(ct); }
    if (!cr) { cr=document.createElement('scroll-carousel'); cr.className='product-gallery__carousel scroll-area full-bleed md:unbleed'; cr.id = cr.id || ('pgc-'+Math.random().toString(36).slice(2)); ct.appendChild(cr); }
    return cr;
  }
  function ensureThumbNav() {
    const { root, imgList, sticky, nav } = grefs(); if (!root) return null;
    let st=sticky, n=nav;
    if (!st) { st=document.createElement('safe-sticky'); st.className='product-gallery__thumbnail-list hidden md:block'; (imgList?.parentNode||root).insertBefore(st, imgList?.nextSibling||null); }
    if (!n)  { n=document.createElement('product-gallery-navigation'); n.className='product-gallery__thumbnail-scroller bleed md:unbleed'; st.appendChild(n); }
    const cr = grefs().carousel; if (cr?.id && !n.hasAttribute('aria-controls')) n.setAttribute('aria-controls', cr.id);
    return n;
  }
  function renderGallery(product) {
    const cr = ensureCarousel(); if (!cr) return;
    if (BOOTING && cr.querySelector('.product-gallery__media')) {
      BOOTING = false;
      return; // don't on initial load
    }
    const media = (Array.isArray(product.media) && product.media.length)
      ? product.media.map(m => ({src:(m.preview_image?.src)||m.src, alt:(hasScene7(m)? product.vendor + ' ' + product.title : m.alt) || product.vendor + ' ' + product.title || ''}))
      : (Array.isArray(product.images) ? product.images.map(src => ({src:String(src).replace(/^\/\//,'https://'), alt:product.title||''})) : []);
    if (!media.length) return;
    cr.innerHTML = media.map((m,i)=>`
      <div class="product-gallery__media snap-center${i===0?' is-initial':''}" data-media-type="image" role="group" aria-label="Item ${i+1} of ${media.length}">
        <img src="${withW(m.src,1000)}" alt="${m.alt}" srcset="${srcset(m.src)}" width="1000" height="1250" ${i===0?'loading="eager" fetchpriority="high"':'loading="lazy"'}
             sizes="${GALLERY_SIZES}">
      </div>`).join('');
    const nav = ensureThumbNav();
    if (nav) {
      nav.innerHTML = media.map((m,i)=>`
        <button type="button" class="product-gallery__thumbnail" data-media-type="image" data-media-position="${i+1}" aria-current="${i===0?'true':'false'}" aria-label="Go to item ${i+1}">
          <img src="${withW(m.src,1000)}" alt="${m.alt}" srcset="${srcset(m.src,[56,112,168])}" width="1000" height="1250" sizes="56px" class="object-contain">
        </button>`).join('');
    }
    wireGalleryInteractions(); // (re)bind clicks after (re)render
    BOOTING = false;
  }

  // thumbnails → scroll gallery (scoped)
  function wireGalleryInteractions() {
    const { carousel, nav } = grefs();
    if (!carousel || !nav || nav.dataset.wired === '1') return;
    nav.dataset.wired = '1';
    nav.addEventListener('click', (e) => {
      if (!IN_SCOPE(e.target)) return;
      const btn = e.target.closest?.('.product-gallery__thumbnail');
      if (!btn) return;
      e.preventDefault();
      const pos = Number(btn.getAttribute('data-media-position')) || 1;
      const items = qsa('.product-gallery__media', carousel);
      const idx = Math.max(0, Math.min(items.length - 1, pos - 1));
      const target = items[idx];
      if (!target) return;
      try { target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
      catch { const left = target.offsetLeft - (carousel.clientWidth - target.clientWidth) / 2; carousel.scrollTo({ left, behavior: 'smooth' }); }
      qsa('.product-gallery__thumbnail[aria-current="true"]', nav).forEach(b => b.setAttribute('aria-current','false'));
      btn.setAttribute('aria-current','true');
    }, true);
  }

  // ---------- size ordering ----------
  function sizeOrderMapFromProduct(product){
    const opt = (product.options || []).find(o => /size/i.test(o.name || ''));
    const map = new Map();
    if (opt && Array.isArray(opt.values)) {
      opt.values.forEach((v,i) => map.set(String(v).toLowerCase().trim(), i));
    }
    return map;
  }

  const apparelRank = new Map([
    ['xxs',0], ['xs/s',0], ['extra extra small',0], ['xs',1], ['extra small',1],
    ['s',2],   ['small',2], ['s/m',2], ['m',3], ['medium',3], ['m/l',3],
    ['l',4], ['l/xl',4],   ['large',4], ['xl',5], ['extra large',5],
    ['xxl',6],['1x',6], ['2xl',6], ['extra extra large',6],['2x',6], ['xxxl',7], ['3xl',7],['3x',7], ['one size',50], ['os',50]
  ]);

  // ---------- BRA HELPERS ----------
  const CUP_ORDER = ['aa','a','b','c','d','dd','e','f','ff','g','gg','h','hh','i','j','k'];

  function normalizeCup(raw) {
    // strip spaces/slashes/dashes
    let c = String(raw).toLowerCase().replace(/[\s\-\/]+/g,'');
    // common aliases
    if (c === 'ddd') c = 'f';
    if (c === 'eeee') c = 'ff';
    if (c === 'eee') c = 'f';
    return c;
  }

  function parseBraSize(s) {
    const str = String(s).trim();
    // "30D", "30 D", "30-DD", "30DDD", "30 DDD"
    let m = str.match(/^(\d{2,3})\s*[-\s]*([A-Za-z]{1,4})$/);
    if (!m) return { isBra:false, band:Infinity, cup:'zzz', raw:str };
    const band = Number(m[1]);
    const cup  = normalizeCup(m[2]);
    return { isBra:true, band, cup, raw:str };
  }
 
  function sortBraSizesInPlace(items, getName = x => x.name ?? x) {
    return items.sort((x,y) => {
      const A = parseBraSize(getName(x));
      const B = parseBraSize(getName(y));
      if (A.band !== B.band) return A.band - B.band;
      const ia = CUP_ORDER.indexOf(A.cup), ib = CUP_ORDER.indexOf(B.cup);
      if (ia !== -1 && ib !== -1 && ia !== ib) return ia - ib;
      // fallback natural compare
      return String(getName(x)).localeCompare(String(getName(y)), undefined, {numeric:true, sensitivity:'base'});
    });
  }
  // ---------- END BRA HELPERS ----------

  function sortSizes(product, sizes) {
    const getName = s => String(s?.name ?? s);
    const values  = sizes.map(getName);

    // 1) Bra-first logic stays the same
    const braCount = values.filter(v => parseBraSize(v).isBra).length;
    const isBraish = braCount >= Math.ceil(values.length * 0.6);
    if (isBraish) {
      return sortBraSizesInPlace(sizes, s => getName(s));
    }

    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

    // 2) Prefer generic apparelRank
    const rankA = name => apparelRank.get(name.toLowerCase().trim());
    const allHaveApparelRank = values.every(v => rankA(v) != null);

    if (allHaveApparelRank) {
      // Use apparelRank primarily
      return sizes.sort((a, b) => {
        const A = rankA(getName(a));
        const B = rankA(getName(b));
        if (A != null && B != null) return A - B;
        if (A != null) return -1;
        if (B != null) return 1;
        return collator.compare(getName(a), getName(b));
      });
    }

    // 3) Fall back to product-defined order if apparelRank wasn't sufficient
    const productOrder = sizeOrderMapFromProduct(product); // assumed Map(name->index)
    if (productOrder && productOrder.size) {
      const rankP = name => productOrder.get(name.toLowerCase().trim());
      return sizes.sort((a, b) => {
        const A = rankP(getName(a));
        const B = rankP(getName(b));
        if (A != null && B != null) return A - B;
        if (A != null) return -1;
        if (B != null) return 1;
        // final tie-breaker: apparelRank if present, else alpha
        const aA = rankA(getName(a));
        const bA = rankA(getName(b));
        if (aA != null && bA != null) return aA - bA;
        if (aA != null) return -1;
        if (bA != null) return 1;
        return collator.compare(getName(a), getName(b));
      });
    }

    // 4) Last resort: partial apparelRank then alpha
    return sizes.sort((a, b) => {
      const A = rankA(getName(a));
      const B = rankA(getName(b));
      if (A != null && B != null) return A - B;
      if (A != null) return -1;
      if (B != null) return 1;
      return collator.compare(getName(a), getName(b));
    });
  }


  // ---------- render sizes ----------
  const SIZE_FITS = JSON.parse(
    document.getElementById('size-fits-json')?.textContent || '{}'
  );
  let lastChosenSize = (sizeBtnText?.textContent || '').trim();
  function renderSizes(product, selectedVariantId=null, {trackOnSelect = false} = {}){
    if (!sizeList) return;
    sizeList.innerHTML = '';
    const sizes = product.variants.map(v => ({ name: v.option1 || v.title, id: v.id, available: !!v.available }));
    sortSizes(product, sizes);

    const frag = document.createDocumentFragment();
    sizes.forEach((s, i) => {
      const inputId = `pdp-size-${i+1}-${s.id}`;
      const label = document.createElement('label');
      label.className = 'popover__value-option h-stack justify-between gap-2';
      label.setAttribute('for', inputId);

      const input = document.createElement('input');
      input.className = 'sr-only';
      input.type = 'radio';
      input.id = inputId;
      input.name = `${formId}-option1-real`;
      input.dataset.variantId = String(s.id);
      input.value = s.name;

      const span = document.createElement('span');
      const fspan = document.createElement('span');
      fspan.classList = "fits";
      const fits = (SIZE_FITS[s.name]!==undefined && SIZE_FITS[s.name] ? ` (${SIZE_FITS[s.name]})` : "");
      fspan.textContent = fits;
      span.textContent = s.name;

      label.append(input, span, fspan);

      if (!s.available) {
        input.disabled = true;
        label.setAttribute('aria-disabled','true');
        label.style.opacity = '0.45';
        const note = document.createElement('small');
        note.className = 'text-subdued';
        note.textContent = 'Sold out';
        label.appendChild(note);
      }

      input.addEventListener('change', () => {
        lastChosenSize = s.name;
        applyVariant(product, product.variants.find(v => v.id === s.id), {updateUrl: false, track: true});
      });

      frag.appendChild(label);
    });

    sizeList.appendChild(frag);

    const preferred =
      (selectedVariantId && product.variants.find(v => v.id === selectedVariantId)) ||
      (lastChosenSize && product.variants.find(v => (v.option1||v.title) === lastChosenSize)) ||
      product.variants.find(v => v.available) ||                     // <-- move this up
      product.variants.find(v => v.id === (initialVariantJSON?.id)) ||// <-- now after
      product.variants[0];

    if (preferred) {
      const chosen = qsa('input[type="radio"]', sizeList).find(inp => inp.dataset.variantId === String(preferred.id));
      if (chosen) chosen.checked = true;
      lastChosenSize = preferred.option1 || preferred.title;
      applyVariant(product, preferred, {track: !!trackOnSelect}); // sets URL
    }
  }

  // Swap your family-products recommendations for a NEW product id (numeric)
  async function reloadFamilyProductsById(productId, { container } = {}) {
    const root = container || document;

    // Always target the recommendations element itself
    const el = root.querySelector('product-recommendations.jn-family-products');
    if (!el) return;

    // Keep section_id so Shopify renders the right markup, but don't replace the whole section
    let sectionId = el.dataset.sectionId
      || el.closest('[id^="shopify-section-"]')?.id?.replace(/^shopify-section-/, '')
      || '';

    const limit  = el.getAttribute('limit')  || '4';
    const intent = el.getAttribute('intent') || 'complementary';

    const url = `${Shopify.routes.root}recommendations/products`
      + `?product_id=${encodeURIComponent(productId)}`
      + `&limit=${encodeURIComponent(limit)}`
      + `&section_id=${encodeURIComponent(sectionId)}`
      + `&intent=${encodeURIComponent(intent)}`
      + `&_=${Date.now()}`;

    const html = await (await fetch(url, { credentials: 'same-origin' })).text();

    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Pull the fresh <product-recommendations> out of the response
    const fresh = temp.querySelector('product-recommendations.jn-family-products')
              || temp.querySelector('product-recommendations')
              || temp.firstElementChild;

    if (fresh) {
      // Replace ONLY the recommendations node so the product section (and listeners) survive
      el.replaceWith(fresh);

      // Optional: let the theme know a component updated (no full section reload)
      document.dispatchEvent(new CustomEvent('recommendations:updated', { detail: { productId } }));
    }
  }


  // ---------- swatch (color) ----------
  function handleFromSwatch(input){
    if (!input) return '';
    if (input.dataset.handle) return input.dataset.handle;
    if (input.dataset.url) {
      try {
        const u = new URL(input.dataset.url, location.origin);
        const parts = u.pathname.split('/').filter(Boolean);
        const i = parts.indexOf('products'); return i>=0 ? parts[i+1] : parts.at(-1);
      } catch {}
    }
    return '';
  }
  async function onColorChange(input){
    const handle = handleFromSwatch(input);
    if (!handle || handle === activeHandle) return;

    const lab = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const colorName = lab?.getAttribute('title') || lab?.getAttribute('aria-label') || input.value || '';
    if (colorLegendText) colorLegendText.textContent = colorName;

    // change path to sibling product (no variant yet)
    setURL(handle, null);
    activeHandle = handle;
    picker.setAttribute('handle', handle);

    const product = await getProduct(handle);
    if (!product) return;

    renderGallery(product);
    renderSizes(product, null, {trackOnSelect: true});      // will also set ?variant for the chosen size
    reloadFamilyProductsById(product.id);
  }

  // ---------- listeners (STRICTLY SCOPED) ----------
  document.addEventListener('change', (e) => {
    if (e.target?.closest?.('.quick-buy-modal__content')) return;
    const t = e.target;
    if (!IN_SCOPE(t)) return;
    if (t?.matches?.('input.js-sibling-swatch[type="radio"]')) onColorChange(t);
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target?.closest?.('.quick-buy-modal__content')) return;
    if (!IN_SCOPE(e.target)) return;
    const lbl = e.target?.closest?.('label[for]');
    if (!lbl) return;
    const input = document.getElementById(lbl.getAttribute('for'));
    if (input && IN_SCOPE(input) && input.matches('input.js-sibling-swatch[type="radio"]')) {
      queueMicrotask(() => onColorChange(input));
    }
  }, true);

  // ======================= PRELOAD: swatch main images =======================
  const preloadSeen = new Set();
  function ensurePreconnect(url) {
    try {
      const host = new URL(url, location.origin).origin;
      if (!document.querySelector(`link[rel="preconnect"][href="${host}"]`)) {
        const pre = document.createElement('link');
        pre.rel = 'preconnect';
        pre.href = host;
        pre.crossOrigin = '';
        document.head.appendChild(pre);
        const dns = document.createElement('link');
        dns.rel = 'dns-prefetch';
        dns.href = host;
        document.head.appendChild(dns);
      }
    } catch {}
  }
  function preloadImageSet(rawUrl) {
    if (!rawUrl) return;
    const base = String(rawUrl).replace(/^\/\//,'https://');
    if (preloadSeen.has(base)) return;
    preloadSeen.add(base);

    ensurePreconnect(base);

    const ss = srcset(base);
    // Preload via <link> (Chrome supports imagesrcset/imagesizes)
    try {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as  = 'image';
      link.href = withW(base, 1000);
      link.setAttribute('imagesrcset', ss);
      link.setAttribute('imagesizes', GALLERY_SIZES);
      link.fetchPriority = 'low';
      document.head.appendChild(link);
    } catch {}

    // Warm via Image() as a fallback
    try {
      const img = new Image();
      img.decoding = 'async';
      img.sizes = GALLERY_SIZES;
      img.srcset = ss;
      img.src = withW(base, 1000);
      // optional: img.fetchPriority = 'low';
      img.style.position = 'absolute'; img.style.width = '0'; img.style.height = '0'; img.style.clipPath = 'inset(50%)';
      img.onload = img.onerror = () => { if (img.remove) img.remove(); };
      // not appended; browser will fetch anyway
    } catch {}
  }
  function collectSwatchImages() {
    const urls = new Set();
    // inputs
    qsa('input.js-sibling-swatch[type="radio"]', SCOPE).forEach(inp => {
      if (inp.dataset.image) urls.add(inp.dataset.image);
      const lbl = document.querySelector(`label[for="${inp.id}"]`);
      if (lbl?.dataset?.image) urls.add(lbl.dataset.image);
    });
    // also any swatch buttons/labels with data-image inside the color fieldset
    if (colorFS) qsa('[data-image]', colorFS).forEach(el => urls.add(el.dataset.image));
    return Array.from(urls);
  }
  function scheduleInitialPreload() {
    const urls = collectSwatchImages();
    urls.forEach((u, i) => {
      // Stagger to be kind to the network
      setTimeout(() => preloadImageSet(u), i * 150);
    });
  }
  // Hover/focus = immediate preload for that swatch
  document.addEventListener('mouseenter', (e) => {
    if (!IN_SCOPE(e.target)) return;
    const lbl = e.target.closest?.('label[for], [data-image]');
    if (!lbl) return;
    const url = lbl.dataset?.image || (() => {
      const id = lbl.getAttribute?.('for');
      return id ? document.getElementById(id)?.dataset?.image : null;
    })();
    if (url) preloadImageSet(url);
  }, true);
  document.addEventListener('focusin', (e) => {
    if (!IN_SCOPE(e.target)) return;
    const el = e.target.closest?.('[data-image]') || e.target;
    const url = el?.dataset?.image;
    if (url) preloadImageSet(url);
  }, true);
  // ==========================================================================

  // ---------- init ----------
  (async () => {
    const product = await getProduct(activeHandle);
    if (!product) return;

    renderGallery(product);        // ensure nav exists + bind interactions
    scheduleInitialPreload();      // PRELOAD swatch main images (staggered)

    if (urlVariant && product.variants.some(v => v.id === urlVariant)) {
      renderSizes(product, urlVariant, {trackOnSelect: false}); // preselect exact ID from URL
      setURL(product.handle || activeHandle, urlVariant);
    } else {
      renderSizes(product, null, {trackOnSelect: false});
    }
  })();
})();

(function () {
  const mq = window.matchMedia('(max-width: 999px)'); // matches md:hidden
  document.addEventListener('click', (e) => {
    if (!mq.matches) return;                                    // mobile only
    const gallery = e.target.closest('product-gallery');
    if (!gallery) return;
    if (!e.target.closest('.product-gallery__carousel')) return; // only image area
    if (e.target.closest('button, a, [role="button"], .no-tap-zoom')) return; // don't hijack controls
    gallery.querySelector('.product-gallery__zoom-button')?.click();
  }, { passive: true });
})();
